// dependencies
import React, { PropsWithChildren, ReactNode } from "react";
import { ControlProps, GroupBase, components } from "react-select";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faSearch } from "@fortawesome/pro-regular-svg-icons";
import { faCircleX, faPlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { PopoutOption } from "..";
// css
import css from "./PopoutSelect.module.scss";

interface PopoutButtonProps {
	onClick: () => void;
	open?: boolean;
	icon?: IconProp;
	disabled?: boolean;
}

export const PopoutButton = (props: PropsWithChildren<PopoutButtonProps>) => {
	const { onClick, open, icon = faPlus, children, disabled = false } = props;
	return (
		<div className={css.popoutTrigger} onClick={onClick}>
			{children ? (
				// if children are provided here render them
				children
			) : (
				// otherwise it should be our fontawesome icon (default faPlus)
				<div className={`${css.iconButton} ${open ? css.open : ""} ${disabled ? css.buttonDisabled : ""}`}>
					<FontAwesomeIcon
						icon={icon}
						style={{
							fontSize: "10px",
							color: "var(--py-primary-9)",
						}}
					/>
				</div>
			)}
		</div>
	);
};

interface DropdownProps {
	children?: ReactNode;
	readonly isOpen: boolean;
	readonly target: ReactNode;
	readonly onClose: () => void;
}

export const Dropdown = ({ children, isOpen, target, onClose }: DropdownProps) => (
	<div className={css.dropdown} style={{ position: "relative" }}>
		{target}
		{isOpen ? <Menu>{children}</Menu> : null}
		{isOpen ? <Blanket onClick={onClose} /> : null}
	</div>
);

export const DropdownIndicator = () => (
	<div className={css.dropdownIndicator}>
		<FontAwesomeIcon icon={faSearch} />
	</div>
);

export const Control = (props: ControlProps<PopoutOption, false, GroupBase<PopoutOption>>) => {
	// retrieve the props from Select that we need to use here
	const {
		selectProps: { inputValue, clearInputValue },
	} = props;
	return (
		<div className={css.search}>
			<components.Control {...props} />
			{inputValue.length ? (
				// we only render the clear icon if there is text in the input
				<FontAwesomeIcon onClick={clearInputValue} icon={faCircleX} className={css.clearIcon} />
			) : null}
		</div>
	);
};

// styled components

const Menu = (props: JSX.IntrinsicElements["div"]) => <div className={css.menu} {...props} />;
const Blanket = (props: JSX.IntrinsicElements["div"]) => <div className={css.blanket} {...props} />;
